module.exports = __webpack_public_path__ + "static/img/find_team_icon.ece3822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/midAutumnRecall/recall/find_team_icon.png
// module id = Rp0N
// module chunks = 1